import React, { Fragment, useEffect, useState } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";

function DeleteDialog({
  onDelete,
  title,
  cancel = "Cancel",
  deletes = "Deactivate",
  setopen,
  open,
}: any) {
  const [open1, setopen1] = useState(true);

  const onclick = () => {
    setopen1(false);
    setTimeout(() => {
      setopen(false);
    }, 200);
  };

  useEffect(() => {
    if (!open) {
      setopen1(false);
    } else {
      setopen1(true);
    }
  }, [open]);

  if (!open) return null;

  return (
    <Fragment>
      <div
        className={`fixed inset-0 z-[100] bg-erp-navy/45 backdrop-blur-[2px] transition-opacity duration-200 ${
          open1 ? "opacity-100" : "opacity-0"
        }`}
        onClick={onclick}
        aria-hidden
      />

      <div
        role="dialog"
        aria-modal="true"
        aria-label="Confirm deactivate"
        className={`fixed left-1/2 top-1/2 z-[101] w-[min(400px,92vw)] -translate-x-1/2 -translate-y-1/2 overflow-hidden rounded-xl border border-erp-line bg-white shadow-[0_24px_64px_rgba(11,28,44,0.22)] transition-all duration-200 ${
          open1
            ? "scale-100 opacity-100"
            : "scale-95 opacity-0"
        }`}
      >
        <div className="relative border-b border-erp-line bg-gradient-to-r from-white via-white to-erp-danger/5 px-4 py-3">
          <div
            aria-hidden
            className="absolute inset-y-0 left-0 w-[3px] bg-gradient-to-b from-erp-danger via-[#d97706] to-erp-navy"
          />

          <div className="flex items-start justify-between gap-3 pl-1.5">
            <div className="flex min-w-0 items-start gap-3">
              <span className="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border border-erp-danger/25 bg-erp-danger/10 text-erp-danger">
                <WarningAmberRoundedIcon sx={{ fontSize: 22 }} />
              </span>
              <div className="min-w-0 pt-0.5">
                <p className="m-0 text-[10px] font-semibold uppercase tracking-[0.14em] text-erp-muted">
                  Confirm action
                </p>
                <h4 className="m-0 mt-1 text-[14px] font-semibold leading-snug tracking-[-0.01em] text-erp-ink">
                  {title ?? "Are you sure you want to deactivate this record?"}
                </h4>
              </div>
            </div>

            <button
              type="button"
              onClick={onclick}
              className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-md border border-erp-line bg-white text-erp-muted transition-colors hover:border-erp-accent/40 hover:bg-erp-surface hover:text-erp-ink"
              aria-label="Close"
            >
              <ClearIcon sx={{ fontSize: 18 }} />
            </button>
          </div>
        </div>

        <div className="px-4 py-3">
          <p className="m-0 text-[12px] leading-relaxed text-erp-muted">
            This will deactivate the record. You can activate it again later if
            needed.
          </p>
        </div>

        <div className="flex items-center justify-end gap-2 border-t border-erp-line bg-erp-surface/40 px-4 py-3">
          <button
            type="button"
            onClick={onclick}
            className="inline-flex h-8 min-w-[88px] items-center justify-center rounded-md border border-erp-line bg-white px-3 text-[12px] font-semibold capitalize text-erp-muted transition-colors hover:bg-white hover:text-erp-ink"
          >
            {cancel}
          </button>
          <button
            type="button"
            onClick={() => onDelete()}
            className="inline-flex h-8 min-w-[96px] items-center justify-center rounded-md border-0 bg-erp-danger px-3 text-[12px] font-semibold capitalize text-white shadow-[0_2px_6px_rgba(180,35,24,0.25)] transition-colors hover:bg-[#912018]"
          >
            {deletes}
          </button>
        </div>
      </div>
    </Fragment>
  );
}

export default DeleteDialog;
